var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtaLegendA3Fr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a3",
    width: 1587.402,
    height: "297mm",
    viewBox: "0 0 1190.551 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect2",
    d: "M0 0h1190.551v841.89H0z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "rand",
    transform: "translate(1.85 .207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1034",
    d: "M74.627 788.31H753.25c1.333 0 2.412 1.224 2.412 2.735v25.487c0 1.51-1.08 2.736-2.412 2.736H74.627Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text503",
    x: 77.825,
    y: 814.526,
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan84313",
    x: 77.825,
    y: 814.526
  }, "Source: OpenStreetMap contributors \xA9 SBB/CFF/FFS www.tra\uFB01mage.ch www.geops.ch"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text105827",
    x: 78.083,
    y: 798.215,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      lineHeight: 1,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50162",
    x: 78.083,
    y: 798.215
  }, "Sur certaines lignes d\u2019autobus, un suppl\xE9ment doit \xEAtre pay\xE9 et/ou les places doivent \xEAtre r\xE9serv\xE9es. En outre, veuillez noter que la r\xE9servation de places pour v\xE9lo est obligatoire dans les trains InterCity (IC) du 21 mars au 31 octobre. Veuillez consulter")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50164",
    x: 78.083,
    y: 804.215
  }, "les informations concernant votre train dans l\u2019horaire (en ligne). Faute de place, selon le niveau de zoom, toutes les lignes ne sont pas mentionn\xE9es. Toutes les indications sont sans garantie. Sous r\xE9serve de modifications. Le champ d&apos;application fait foi.")))), /*#__PURE__*/React.createElement("g", {
    id: "qr-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect23865",
    d: "M22.453 768.451h51.024v51.024H22.453Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path973",
    d: "M23.91 769.91h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm10.205 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm-46.651 1.458h1.458v1.458H23.91Zm8.747 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458Zm8.747 0h1.458v1.458h-1.458Zm-46.651 1.458h1.458v1.458H23.91Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458H44.32zm2.916 0h1.457v1.458h-1.457zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458Zm2.915 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm-46.651 1.458h1.458v1.457H23.91Zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0H31.2v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H44.32zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm7.29 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458Zm2.916 0h1.458v1.457H64.73zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458ZM23.91 775.74h1.458v1.458H23.91Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm2.916 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458ZM23.91 777.2h1.458v1.458H23.91Zm8.747 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm11.662 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm8.747 0h1.458v1.458h-1.458Zm-46.651 1.458h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H44.32zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-24.783 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm-32.073 1.458h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm5.832 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458ZM23.91 783.03h1.458v1.457H23.91Zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.915 0H31.2v1.457h-1.458zm1.458 0h1.458v1.457H31.2zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm5.831 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458Zm1.458 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457h-1.458Zm1.458 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458Zm-46.651 1.457h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm8.747 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458Zm-45.193 1.458h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458H44.32zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-39.361 1.458h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm-40.82 1.458h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm10.204 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm7.29 0h1.457v1.458h-1.458zm1.457 0h1.458v1.458h-1.458ZM23.91 790.32h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0H31.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.831 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H64.73zm4.373 0h1.458v1.458h-1.458Zm-45.193 1.458h1.458v1.458H23.91Zm2.916 0h1.458v1.458h-1.458zm2.915 0H31.2v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm8.748 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-40.82 1.458h1.459v1.457h-1.458zm1.459 0h1.457v1.457h-1.457zm1.457 0H31.2v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H44.32zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458Zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H64.73zm4.373 0h1.458v1.457h-1.458zm-42.277 1.457h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H31.2zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-45.193 1.458h1.458v1.458h-1.458zm5.831 0h1.458v1.458H31.2zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm2.916 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458ZM23.91 797.61h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.83 0h1.459v1.458h-1.458zm2.917 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458Zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-40.82 1.458h1.459v1.458h-1.458zm1.459 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H31.2zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458H64.73zm4.373 0h1.458v1.458h-1.458Zm-45.193 1.458h1.458v1.458H23.91Zm7.29 0h1.457v1.458H31.2zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458H44.32zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm-46.651 1.458h1.458v1.458H23.91Zm2.916 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458ZM23.91 803.44h1.458v1.457H23.91Zm4.374 0h1.457v1.457h-1.457zm1.457 0H31.2v1.457h-1.458zm7.29 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm5.832 0h1.458v1.457h-1.458zm8.747 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458Zm2.916 0h1.458v1.457H64.73zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm-43.735 1.457h1.458v1.458H23.91Zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H31.2zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm7.29 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm-34.988 1.458h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm-46.651 1.458h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm2.916 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458Zm-45.193 1.458h1.458v1.458H23.91Zm8.747 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm4.373 0h1.458v1.458H44.32zm7.29 0h1.457v1.458h-1.458Zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458ZM23.91 810.73h1.458v1.458H23.91Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm4.374 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm-46.651 1.458h1.458v1.457H23.91Zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0H31.2v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458Zm2.916 0h1.458v1.457h-1.458zm5.831 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H64.73zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm-43.735 1.457h1.458v1.458H23.91Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458Zm-45.193 1.458h1.458v1.458H23.91Zm8.747 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H44.32zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458H64.73zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm-43.735 1.458h1.458v1.458H23.91Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458Zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458z",
    style: {
      display: "inline",
      fill: "#000",
      strokeWidth: 0.208264
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "sbb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect22814",
    d: "M971.83 22.677h196.044v22.94H971.83z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect397399",
    d: "M973.281 23.927h192.107v20.659H973.281z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    d: "M973.28 44.374h60.703V24.139h-60.702v20.235Z",
    style: {
      fill: "#e42328",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    d: "M1009.012 32.708h6.564v-5.196h3.091v5.196h6.563l-5.28-5.196h3.918l6.745 6.745-6.745 6.744h-3.92l5.28-5.196h-6.56v5.196h-3.093v-5.196h-6.563l5.28 5.196h-3.916l-6.744-6.744 6.744-6.745h3.917",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    d: "M1040.247 36.972c-.039 3.492 2.896 5.04 6.03 5.04 3.848 0 5.891-1.944 5.891-4.543 0-3.212-3.173-3.867-4.205-4.123-3.55-.913-4.224-1.052-4.224-2.142 0-1.19 1.15-1.606 2.143-1.606 1.488 0 2.698.435 2.796 2.143h3.015c0-3.273-2.717-4.561-5.672-4.561-2.559 0-5.296 1.388-5.296 4.285 0 2.658 2.122 3.471 4.226 4.026 2.082.554 4.203.813 4.203 2.339 0 1.448-1.666 1.766-2.757 1.766-1.666 0-3.133-.735-3.133-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    d: "M1057.203 29.933h2.915c1.11 0 2.143.277 2.143 1.626 0 1.19-.814 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.741h6.861c2.559 0 5-1.23 5-4.106 0-1.764-.875-3.094-2.6-3.59a3.106 3.106 0 0 0 1.926-2.956c0-2.637-1.826-3.51-4.524-3.51h-6.663v14.162Zm3.113-6.307h3.39c1.329 0 2.241.576 2.241 2.023 0 1.467-1.07 1.865-2.3 1.865h-3.33",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    d: "M1071.14 29.933h2.916c1.11 0 2.142.277 2.142 1.626 0 1.19-.813 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.741h6.861c2.56 0 4.998-1.23 4.998-4.106 0-1.764-.872-3.094-2.598-3.59a3.106 3.106 0 0 0 1.924-2.956c0-2.637-1.824-3.51-4.522-3.51h-6.663v14.162Zm3.115-6.307h3.39c1.33 0 2.242.576 2.242 2.023 0 1.467-1.07 1.865-2.3 1.865h-3.331",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2889",
    d: "M1099.666 32.272c-.377-3.272-2.994-5.096-6.108-5.096-4.384 0-6.96 3.273-6.96 7.477 0 4.086 2.576 7.358 6.96 7.358 3.471 0 5.91-2.26 6.227-5.792h-3.016c-.237 1.865-1.308 3.173-3.211 3.173-2.796 0-3.849-2.38-3.849-4.74 0-2.479 1.053-4.86 3.849-4.86 1.546 0 2.896 1.071 3.094 2.479",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    d: "M1101.702 41.674h3.114v-5.851h5.93v-2.42h-5.93v-3.272h6.842v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2893",
    d: "M1113.551 41.674h3.105v-5.851h5.924v-2.42h-5.926v-3.272h6.835v-2.617h-9.938",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2895",
    d: "M1130.233 41.674h3.122v-5.851h5.924v-2.42h-5.924v-3.272h6.834v-2.617h-9.955",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2897",
    d: "M1142.457 41.674h3.104v-5.851h5.924v-2.42h-5.924v-3.272h6.852v-2.617h-9.957",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2899",
    d: "M1153.554 36.972c-.035 3.492 2.89 5.04 6.031 5.04 3.854 0 5.889-1.944 5.889-4.543 0-3.212-3.177-3.867-4.194-4.123-3.55-.913-4.228-1.052-4.228-2.142 0-1.19 1.141-1.606 2.142-1.606 1.48 0 2.695.435 2.801 2.143h2.998c0-3.273-2.712-4.561-5.656-4.561-2.57 0-5.3 1.388-5.3 4.285 0 2.658 2.124 3.471 4.23 4.026 2.07.554 4.193.813 4.193 2.339 0 1.448-1.66 1.766-2.748 1.766-1.678 0-3.14-.735-3.14-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "title",
    transform: "translate(.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path523",
    d: "M-.224 22.677h210.44c.504 0 .914.528.914 1.177V61.42c0 .65-.41 1.178-.914 1.178H-.224Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text745",
    x: 22.102,
    y: 48.444,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 18,
      fontFamily: "SBBWeb-Light,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5661",
    x: 22.102,
    y: 48.444
  }, "Abonnement demi-tarif")))), /*#__PURE__*/React.createElement("g", {
    id: "legend",
    transform: "translate(0 -49.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect426128-0-8-3-9-2",
    width: 196.237,
    height: 127.234,
    x: 15.117,
    y: 117.193,
    rx: 2.551,
    ry: 2.476,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scaleline",
    transform: "translate(0 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2491",
    d: "M22.815 226.519h135.509v13.898H22.815Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "text2343",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text756",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(88.55 236.294)"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan750",
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan752",
    x: 9.731,
    y: 0,
    style: {
      letterSpacing: ".00342em"
    }
  }, "k"), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan754",
    x: 13.388,
    y: 0
  }, "m")))), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    d: "M175.435 226.52v13.371l-152.168.074V226.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".9031px",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g777",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text763",
    x: 22.21,
    y: 154.043,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50266",
    x: 22.21,
    y: 154.043
  }, "Chemins")), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50268",
    x: 22.21,
    y: 162.793
  }, "de fer"))), /*#__PURE__*/React.createElement("g", {
    id: "g775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line765",
    d: "M23.628 142.724h32.28",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g795",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text781",
    x: 121.817,
    y: 153.957,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50288",
    x: 121.817,
    y: 153.957
  }, "Transports")), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50290",
    x: 121.817,
    y: 162.707
  }, "\xE0 c\xE2bles"))), /*#__PURE__*/React.createElement("g", {
    id: "g793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line783",
    d: "M122.891 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g838",
    transform: "translate(-50.12 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7-1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text809",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(171.621 196.83)"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan51026",
    x: 0,
    y: 0
  }, "Demandez la")), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan51028",
    x: 0,
    y: 8.75
  }, "validit\xE9 sur")), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan51030",
    x: 0,
    y: 17.5
  }, "place")))), /*#__PURE__*/React.createElement("g", {
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line830",
    d: "M172.523 185.415v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line832",
    d: "M175.457 185.415h27.878",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line834",
    d: "M204.802 185.415v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g866",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text852",
    x: 171.621,
    y: 153.957,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50310",
    x: 171.621,
    y: 153.957
  }, "Bateaux"))), /*#__PURE__*/React.createElement("g", {
    id: "g864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line854",
    d: "M172.523 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g904",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text880",
    x: 72.072,
    y: 153.957,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50204",
    x: 72.072,
    y: 153.957
  }, "Autobus"))), /*#__PURE__*/React.createElement("g", {
    id: "g902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line882",
    d: "M73.547 142.724h31.707",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line892",
    d: "M73.26 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g937",
    transform: "translate(0 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text920",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(22.21 196.83)"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan939",
    x: 0,
    y: 0
  }, "Voyages \xE0"))), /*#__PURE__*/React.createElement("text", {
    id: "text920-3",
    x: 21.79,
    y: 205.621,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan941-7",
    x: 21.79,
    y: 205.621
  }, "prix r\xE9duit")))), /*#__PURE__*/React.createElement("g", {
    id: "g935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line923",
    d: "M23.485 172.15h32.279",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line925",
    d: "M23.485 180.994h32.279",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line927",
    d: "M23.486 185.415h32.279",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line929",
    d: "M23.772 176.572h31.707",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line931",
    d: "M23.485 176.572h32.279",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1048",
    transform: "translate(-50.12 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1051",
    style: {
      isolation: "isolate"
    },
    transform: "translate(0 9.442)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1049",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(121.818 196.83)"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1057"
  }, "r\xE9duction")))), /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1043",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(121.818 196.83)"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan50432",
    x: 0,
    y: 0
  }, "Pas de")))), /*#__PURE__*/React.createElement("path", {
    id: "line1046",
    d: "M122.891 185.415h32.28",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "state-publisher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text2350",
    style: {
      isolation: "isolate"
    },
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1052",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(51.046 128.648)"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1050",
    x: 0,
    y: 0
  }, "***publishedAt***")))), /*#__PURE__*/React.createElement("g", {
    id: "text2347",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1057",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(22.21 128.648)"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan44990",
    x: 0,
    y: 0
  }, "Cr\xE9\xE9 le")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtaLegendA3Fr);
export default __webpack_public_path__ + "static/media/hta_legend_a3_fr.c6528f5c1a2215a2e05fcb0afdf97935.svg";
export { ForwardRef as ReactComponent };